// fetchOrders.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { getAllOrders } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchOrders = async (
  setOrders,
  page = 1,
  search = ""
) => {
  try {
    const response = await getAllOrders(page, search);

    if (response.status === 200) {
      setOrders(response.data);
    } else {
      message.error("Failed to fetch orders.");
    }
  } catch (error) {
    message.error(
      error?.response?.data?.error ||
      "An error occurred while fetching orders."
    );
  }
};
